import React from 'react';

class Facts extends React.Component {
    render() {
        return (
            <section id="facts" className="facts">
                <div className="container">

                    <div className="section-title">
                        <h2>Technologies I Use</h2>
                        {/* <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.</p> */}
                    </div>

                    <div className="row no-gutters">

                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/html-5.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>HTML</strong>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/css3.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>CSS</strong>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/javascript.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>JavaScript</strong>
                            </div>
                        </div>
                     
                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/bootstrap-4.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>Bootstrap</strong>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/react.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>React JS</strong>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/redux.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>Redux</strong>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/java.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>Java</strong>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/material-ui-1.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>Material UI</strong>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/react-bootstrap.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>React Bootstrap</strong>
                            </div>
                        </div>
                     
                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/nodejs.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>Node JS</strong>
                            </div>
                        </div>
                    
                    
                     
                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/csharp.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>C#</strong>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/netframe.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>Microsoft .NET Framework</strong>
                            </div>
                        </div>
                        {/* <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/javascript.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>JavaScript</strong>
                            </div>
                        </div> */}
                   
                      
                        
                       
                        <div className="col-lg-2 col-md-2 d-md-flex align-items-md-stretch" data-aos="fade-up">
                            <div className="count-box text-center">
                                <img src="/assets/img/skills/mongodb.svg" width="50"/>
                                <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                <strong>MongoDB</strong>
                            </div>
                        </div>
                      

                      

                        {/* <div className="col-lg-3 col-md-6 d-md-flex align-items-md-stretch" data-aos="fade-up" data-aos-delay="300">
                            <div className="count-box">
                                <i className="bi bi-people"></i>
                                <span data-purecounter-start="0" data-purecounter-end="32" data-purecounter-duration="1" className="purecounter"></span>
                                <p><strong>Hard Workers</strong> rerum asperiores dolor</p>
                            </div>
                        </div> */}

                    </div>

                </div>
            </section>

        )
    }
}

export default Facts;